export default function ImportantNoteIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path
        d="M12.7506 14.3516H6.32199C5.43439 14.3516 4.71484 15.0711 4.71484 15.9587V38.4587C4.71484 41.1214 6.87346 43.2801 9.53627 43.2801C12.1991 43.2801 14.3577 41.1214 14.3577 38.4587V15.9587C14.3577 15.0711 13.6382 14.3516 12.7506 14.3516Z"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3566 36.8538V6.31808C14.3566 5.43049 15.0761 4.71094 15.9637 4.71094H41.678C42.5655 4.71094 43.2852 5.43049 43.2852 6.31808V38.4609C43.2852 41.1237 41.1264 43.2824 38.4637 43.2824H9.53516"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7852 12.75H36.8566"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7852 20.7812H36.8566"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7852 28.8203H36.8566"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
